// extracted by mini-css-extract-plugin
export default {"container":"contact_container__fL-+N","title":"contact_title__XSo1K","messageArea":"contact_messageArea__fqq23"};